import { render, staticRenderFns } from "./DeleteCourse.vue?vue&type=template&id=1c945a4b&scoped=true"
import script from "./DeleteCourse.vue?vue&type=script&lang=js"
export * from "./DeleteCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c945a4b",
  null
  
)

export default component.exports